import api from './api';

// جلب جميع الخدمات
export const getServices = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/services/admin/all?${queryParams}`);
  return response.data;
};

export const getServiceById = async (id) => {
  const response = await api.get(`/services/${id}`);
  return response.data;
};

export const createService = async (data) => {
  const response = await api.post('/services', data);
  return response.data;
};

export const updateService = async (id, data) => {
  const response = await api.put(`/services/${id}`, data);
  return response.data;
};

export const deleteService = async (id) => {
  const response = await api.delete(`/services/${id}`);
  return response.data;
};

export const addServiceReview = async (id, reviewData) => {
  const response = await api.post(`/services/${id}/reviews`, reviewData);
  return response.data;
};

export const getServiceBySlug = async (slug) => {
  const response = await api.get(`/services/${slug}`);
  return response.data;
};
